import { googleConfigured } from "../auth";

/**
 * Where content lives. Env vars (REACT_APP_ prefix for CRA, all public):
 *   REACT_APP_GCS_BUCKET          public content bucket: production/ live copies, assets/
 *   REACT_APP_GCS_STAGING_BUCKET  private drafts bucket (default "<bucket>-staging")
 * Bucket CORS must allow the site's origins with the Authorization header.
 */
const PUBLIC_BUCKET = process.env.REACT_APP_GCS_BUCKET || "";

/**
 * Bucket names. Drafts live in a separate, never-public bucket so the main
 * bucket can be world-readable without exposing unpublished work.
 */
export const BUCKETS = {
	public: PUBLIC_BUCKET,
	staging:
		process.env.REACT_APP_GCS_STAGING_BUCKET ||
		(PUBLIC_BUCKET ? `${PUBLIC_BUCKET}-staging` : ""),
};

/** Site-wide config objects in the public bucket. */
export const CONFIG_PATHS = {
	settings: "production/config/site.json",
	reading: "production/config/research-signal.json",
	llms: "production/config/llms.txt",
};

/** Admin-only config objects in the private staging bucket. */
export const PRIVATE_CONFIG_PATHS = {
	// The current share-link key; only its hash goes in the public site.json.
	shareKey: "staging/config/share-link.json",
};

export const STORAGE_API = "https://storage.googleapis.com";

/** JSON API object collection URL for a bucket. */
export const objectsApi = (bucket) => `${STORAGE_API}/storage/v1/b/${bucket}/o`;

/** JSON API upload URL for a bucket. */
export const uploadApi = (bucket) => `${STORAGE_API}/upload/storage/v1/b/${bucket}/o`;

/** Folder holding every markdown file of a type at a stage ("staging" | "production"). */
export const contentPrefix = (stage, type) => `${stage}/content/${type}/`;

/** Object path of one entry's markdown at a stage ("staging" | "production"). */
export const contentPath = (stage, type, slug) => `${contentPrefix(stage, type)}${slug}.md`;

/** Bucket that holds a stage: drafts in staging, live copies in the public bucket. */
export const bucketFor = (stage) => (stage === "staging" ? BUCKETS.staging : BUCKETS.public);

/** True when the admin write path is usable: bucket known and Google sign-in available. */
export function gcsConfigured() {
	return Boolean(BUCKETS.public && googleConfigured());
}

/** True when the public read path is usable: only the bucket name is needed. */
export function gcsPublicConfigured() {
	return Boolean(BUCKETS.public);
}
